import FocusManager from '../utils/focus-manager';
import ScrollManager from '../utils/scroll-manager';

export default function initHeaderNavigation() {
    new Header(document.getElementById('main-header-navigation'));
}

/**
 * @param {HTMLElement}       $el                                  HTML Element header
 * @param {HTMLElement}       $body                                HTML Body
 * @param {HTMLButtonElement} $menuToggler                         Toggler du menu
 * @param {HTMLElement}       $mainHeaderNav                       Le menu principal
 * @param {integer}           mobileBreakpoint                     Breakpoint mobile
 * @param {string}            initializedDevice                    Nom du device initialisé (mobile | desktop)
 * 
 */
class Header {
    $el : HTMLElement | null;
    $body : HTMLElement | null;
    $menuToggler : HTMLButtonElement | null | undefined;
    $mainHeaderNav : HTMLElement | null | undefined;
    mobileBreakpoint : number;
    initializedDevice  : string | null;
    $isAnchorNav : HTMLElement | null | undefined;

    constructor($el : HTMLElement | null) {
        this.$el = $el;
        this.$body = document.querySelector('body');
        this.$menuToggler = $el?.querySelector('.js-main-header-burger');
        this.$mainHeaderNav = $el?.querySelector('.js-main-header-nav');
        this.mobileBreakpoint = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--breakpoint-main-header')) + 1;
        this.initializedDevice = null;

        this.init();
        window.addEventListener('resize', this.init.bind(this));
    }

    /**
     * Initialise le header dans le bon device en fonction
     * de la taille de l'écran (mobile ou desktop)
     *
     * @return {void}
     */
    init() {
        if (window.innerWidth < this.mobileBreakpoint && this.initializedDevice !== 'mobile') {
            this.initMobile();
        } else if (window.innerWidth >= this.mobileBreakpoint && this.initializedDevice !== 'desktop') {
            this.initDesktop();
        }
    }

    /**
     * Initialise le header mobile
     *
     * @return {void}
     */
    initMobile() {
        this.initializedDevice = 'mobile';

        // Ouverture / Fermeture du menu au clique sur le toggler du menu
        if (this.$menuToggler) {
            this.$menuToggler.addEventListener('click', this.mobileClickMenuTogglerHandler.bind(this));
        }
        // Fermeture du menu à l'appuie sur la touche Escape
        document.addEventListener('keydown', this.mobileKeyDownDocumentHandler.bind(this));
    }

    /**
     * Fonction à éxécuter au clique sur le toggler du menu
     *
     * @return {void}
     */
    mobileClickMenuTogglerHandler() {
        if (this.$el?.classList.contains('open')) {
            this.closeMobileMenu();
        } else {
            this.openMobileMenu();
        }
    }

    /**
     * Fonction à éxécuter à l'appuie sur une touche du clavier
     *
     * @return {void}
     */
    mobileKeyDownDocumentHandler(evt: KeyboardEvent) {
        if (evt.key === 'Escape' && this.$el?.classList.contains('open')) {
            this.closeMobileMenu();
        }
    }

    /**
     * Initialise le header desktop
     *
     * @return {void}
     */
    initDesktop() {
        this.destroyMobile();
        this.initializedDevice = 'desktop';
    }

    /**
     * Détruit le header mobile
     *
     * @return {void}
     */
    destroyMobile() {
        // On ré-autorise le scroll dans la page
        ScrollManager.preventScroll(false);

        // On enlève la contrainte du focus
        FocusManager.untrapFocus();

        // On ferme le menu s'il était ouvert pour éviter les erreurs
        this.$el?.classList.remove('open');
        this.$body?.classList.remove('menu-is-open');

        // Suppression des events bind lors de l'initialisation du header mobile
        if (this.$menuToggler) {
            this.$menuToggler.removeEventListener('click', this.mobileClickMenuTogglerHandler);
        }
    }

    /**
     * Ouvre le menu mobile
     *
     * @return {void}
     */
    openMobileMenu() {
        this.$el?.classList.add('open');
        this.$body?.classList.add('menu-is-open');

        ScrollManager.preventScroll(true);
        
        FocusManager.trapFocus(
            [this.$el?.querySelector('[data-trap-focus="main-header"]')]
        );
    }

    /**
     * Ferme le menu mobile
     *
     * @return {void}
     */
    closeMobileMenu() {
        this.$el?.classList.remove('open');
        this.$body?.classList.remove('menu-is-open');

        // On remet le scroll de la page
        ScrollManager.preventScroll(false);

        // On enlève la contrainte du focus
        FocusManager.untrapFocus();
    }
}
